export default __webpack_public_path__ + "static/media/sduzrdd.84911424.png";